import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { AlertService } from './alert.service';
import { FuseAlertAppearance, FuseAlertType } from '@fuse/components/alert/alert.types';
import { FuseAlertComponent } from '@fuse/components/alert';
import { MatIconModule } from '@angular/material/icon';

export class Alert {
  message: '';
  appearance: FuseAlertAppearance = 'soft';
  dismissed: boolean = false;
  dismissible: boolean = false;
  name: string;
  showIcon: boolean = true;
  type: FuseAlertType = 'primary';

  constructor(alert: Alert) {
    this.message = alert.message;
    this.appearance = alert.appearance;
    this.dismissed = alert.dismissed;
    this.dismissible = alert.dismissible;
    this.name = alert.name;
    this.showIcon = alert.showIcon;
    this.type = alert.type;
  }
}

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    standalone: true,
    imports: [
      FuseAlertComponent,
      MatIconModule,
    ]
})
export class AlertComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: Alert,
    private _alertService: AlertService,
  ) {}

  handleClose(): void {
    this._alertService.dismiss();
  }
}
